/**
 * Please note: These classes mainly serve as 'loose' models of the underlying data structure. 'Loose' because the type
 * annotations are not used by the build system. However, IDEs like PHPstorm help with autocomplete and a basic type check.
 */

export class SsoSystem {
    /**
     * @type {int}
     */
    id;

    /**
     * @type {int}
     */
    numberOfUsers;

    /**
     * @type {string}
     */

    name = "";

    /**
     * @type {SsoSystemType}
     */
    type = new SsoSystemType();

    /**
     * @type {Array <Domain>}
     */
    domains = [];

    /**
     * @type {boolean}
     */
    allowInternalAuth = false;

    /**
     * @type {Configuration}
     */
    configuration = new Configuration();
}

export class SsoSystemType {
    /**
     * @type {int}
     */
    id = SSO_SYSTEM_TYPE_SAML2_ID;
}

export class Domain {
    /**
     * @type {string}
     */
    name;
}

class Configuration {
    /**
     * @type {string}
     */
    idpEntityId = "";
    /**
     * @type {string}
     */
    idpSingleSignOnServiceUrl = "";
    /**
     * @type {string}
     */
    idpX509cert;
    /**
     * @type {string}
     */
    spEntityId = "";
    /**
     * @type {string}
     */
    spAssertionConsumerServiceUrl = "";
    /**
     * @type {string}
     */
    spSingleLogoutServiceUrl = "";
}

export const SSO_SYSTEM_TYPE_SAML2_ID = 1;
export const SSO_SYSTEM_TYPE_OAUTH2_ID = 2;
export const SSO_SYSTEM_TYPES = [{ id: SSO_SYSTEM_TYPE_SAML2_ID, label: "SAML V2" }, { id: SSO_SYSTEM_TYPE_OAUTH2_ID, label: "OAuth V2" }];



// WEBPACK FOOTER //
// ./src/components/admin/sso-system/SsoSystem.js